<div class="user-details-dialog dialog">
  <div class="user-details-dialog-header dialog-header">
    <!-- <img
      class="user-details-dialog-header-user-image"
      [src]="dialogData.profilePictureUrl"
      alt="user icon"
    /> -->
    <app-user-thumb-nail [userEmail]="dialogData.createdByEmail" class="user-details-dialog-header-user-image"></app-user-thumb-nail>
    <span class="user-details-dialog-header-user-details">{{
      dialogData.createdByName
    }}</span>
    <span
      class="user-details-dialog-header-close dialog-close"
      (click)="close()" (keypress)="close()"
    >
      <img alt="close"
        [src]="'images/close.svg' | assetUrl"
        class="black-icon cursor-pointer"
        draggable="false"
      />
    </span>
  </div>
  <mat-dialog-content class="user-details-dialog-content dialog-content">
    <p class="user-details-dialog-content-header">Email</p>
    <a
      class="user-details-dialog-content-value"
      href="mailto:{{ dialogData.createdByEmail }}"
      >{{ dialogData.createdByEmail }}</a
    >
  </mat-dialog-content>
</div>
